import { cn } from '@bridebook/aura';
import { useFieldContext } from './field';

export type FieldHelperTextProps = React.ComponentPropsWithoutRef<'div'>;

export const FieldHelperText = ({ className, children, ...props }: FieldHelperTextProps) => {
  const context = useFieldContext();
  const isError = context?.error;

  if (!children) return null;

  return (
    <div className={cn('typo-sm', isError ? 'text-errors' : 'text-space-60', className)} {...props}>
      {children}
    </div>
  );
};

FieldHelperText.displayName = 'FieldHelperText';
